import styled, { css } from 'styled-components';
import theme from 'shared/assets/style/theme';
import { pwaStyleAdapter } from '../../utils/mobileSupported';

const errorBorder = css`
  border: 1px solid red;
`;

const BoxErrorLayout = css`
  border-bottom-left-radius: 0.6em;
  border-bottom-right-radius: 0.6em;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-top: none;
  &:focus {
    border-bottom-left-radius: 0.6em;
    border-bottom-right-radius: 0.6em;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-top: none;
  }
`;

export const TextInput = styled.input`
  width: 100%;
  height: ${pwaStyleAdapter(42, 'px')};
  text-align: left;
  padding-left: ${pwaStyleAdapter(1, 'em')};
  box-shadow: none;
  background-color: unset;
  outline: none;
  padding-left: ${({ icon }) => pwaStyleAdapter(icon ? 30 : 10, 'px')};
  color: white;
  font-size: ${pwaStyleAdapter(1, 'rem')};
  ::placeholder,
  ::-webkit-input-placeholder {
    font-size: ${pwaStyleAdapter(1, 'rem')};
    color: ${theme.palette.common[1]};
  }
  &:focus {
    font-size: ${pwaStyleAdapter(1, 'rem')};
  }
  ${({ theme }) => theme}
  ${({ error, boxErrorLayout }) => error && !boxErrorLayout && errorBorder}
  ${({ error, boxErrorLayout }) => error && boxErrorLayout && BoxErrorLayout}
`;

